import { getLiteral } from 'utils/getLiteral';

export default () => ({
    columnDefs: [
        {
            colId: 'numLine',
            headerName: '#',
            field: 'numLine',
            cellRenderer: 'rowNumberCell',
            width: 60,
            resizable: false,
            pinned: 'left',
            suppressSizeToFit: true,
        },
        {
            colId: 'name',
            headerName: getLiteral('label_name'),
            field: 'name',
            cellRenderer: 'CarouselReadCell',
            cellRendererParams: {
                isSquared: true,
                imageSize: 'big',
                withEmptyPlaceholder: true,
                isReadOnly: true,
                otherFields: {
                    rowImageSrc: 'rowImageUrl',
                    rowImagePlaceholder: 'rowImageUrlFallback',
                    carouselFieldId: 'imageListUrls',
                    carouselImageSrc: 'src',
                    carouselImagePlaceholder: 'fallbackSrc',
                },
            },
            flex: 1,
            minWidth: 200,
            maxWidth: 280,
            pinned: 'left',
        },
        {
            colId: 'rateprice',
            headerName: getLiteral('label_price'),
            field: 'rateprice',
            cellRenderer: 'currencyCell',
            cellRendererParams: {
                otherFields: {
                    symbol: 'currencySymbol',
                },
                currencyPosition: 'after',
            },
            crudType: 'currency',
            minWidth: 180,
        },
        {
            colId: 'ratediscount1',
            headerName: getLiteral('label_rates_discount1'),
            field: 'ratediscount1',
            cellRenderer: 'percentageCell',
            cellRendererParams: {
                inputParams: {
                    postComponent: <span>%</span>,
                },
            },
            crudType: 'percentage',
            minWidth: 180,
        },
        {
            colId: 'ratediscount2',
            headerName: getLiteral('label_rates_discount2'),
            field: 'ratediscount2',
            cellRenderer: 'percentageCell',
            cellRendererParams: {
                inputParams: {
                    postComponent: <span>%</span>,
                },
            },
            crudType: 'percentage',
            minWidth: 180,
        },
        {
            colId: 'ratediscount3',
            headerName: getLiteral('label_rates_discount3'),
            field: 'ratediscount3',
            cellRenderer: 'percentageCell',
            cellRendererParams: {
                inputParams: {
                    postComponent: <span>%</span>,
                },
            },
            crudType: 'percentage',
            minWidth: 180,
        },
        {
            colId: 'ratediscount4',
            headerName: getLiteral('label_rates_discount4'),
            field: 'ratediscount4',
            cellRenderer: 'percentageCell',
            cellRendererParams: {
                inputParams: {
                    postComponent: <span>%</span>,
                },
            },
            crudType: 'percentage',
            minWidth: 180,
        },
        {
            colId: 'totaldiscount',
            headerName: getLiteral('label_discount'),
            field: 'totaldiscount',
            cellRenderer: 'textCell',
            cellRendererParams: {
                align: 'right',
            },
            minWidth: 180,
        },
    ],
});
